<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-post-15-arms-imports-mideast-box">
  <!-- Artboard: xs -->
  <div
    id="g-post-15-arms-imports-mideast-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.41772151898734;"
  >
    <div
      id="g-post-15-arms-imports-mideast-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-15-arms-imports-mideast-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.7244%;margin-top:-9.6px;left:1.208%;width:111px;"
    >
      <p class="g-pstyle0">Imported from</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.7244%;margin-top:-9.6px;left:38.5542%;width:105px;"
    >
      <p class="g-pstyle0">United States</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.7244%;margin-top:-9.6px;left:73.2388%;width:64px;"
    >
      <p class="g-pstyle0">France</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:4.3826%;margin-top:-9.6px;left:38.5542%;width:48px;"
    >
      <p class="g-pstyle0">Italy</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:4.3826%;margin-top:-9.6px;left:73.2388%;width:40px;"
    >
      <p class="g-pstyle0">UK</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:7.1674%;margin-top:-9.6px;left:38.5542%;width:63px;"
    >
      <p class="g-pstyle0">Russia</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:7.1674%;margin-top:-9.6px;left:73.2388%;width:63px;"
    >
      <p class="g-pstyle0">Others</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:10.0103%;margin-top:-9.1px;left:0.688%;width:41px;"
    >
      <p class="g-pstyle1">0%</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:10.0103%;margin-top:-9.1px;left:21.437%;width:48px;"
    >
      <p class="g-pstyle1">25%</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:10.0103%;margin-top:-9.1px;left:45.5732%;width:49px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:10.0103%;margin-top:-9.1px;left:70.5384%;width:47px;"
    >
      <p class="g-pstyle1">75%</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:10.0103%;margin-top:-9.1px;left:88.9857%;width:54px;"
    >
      <p class="g-pstyle1">100%</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.3826%;margin-top:-9.6px;left:1.0319%;width:71px;"
    >
      <p class="g-pstyle2">Bah<span class="g-cstyle0">r</span>ain</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:21.0915%;margin-top:-9.6px;left:1.0319%;width:77px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle1">L</span>ebanon</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:27.5472%;margin-top:-9.6px;left:1.0319%;width:102px;"
    >
      <p class="g-pstyle3">Saudi Arabia</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:34.5092%;margin-top:-9.6px;left:1.0319%;width:56px;"
    >
      <p class="g-pstyle2">Is<span class="g-cstyle0">r</span>ael</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:41.218%;margin-top:-9.6px;left:1.0319%;width:65px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle2">K</span>u<span class="g-cstyle0">w</span>ait
      </p>
    </div>
    <div
      id="g-ai0-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:47.9269%;margin-top:-9.6px;left:1.0319%;width:58px;"
    >
      <p class="g-pstyle2">Qa<span class="g-cstyle0">t</span>ar</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:54.6358%;margin-top:-9.6px;left:1.0319%;width:151px;"
    >
      <p class="g-pstyle4">United Arab Emirates</p>
    </div>
    <div
      id="g-ai0-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:61.4712%;margin-top:-9.6px;left:1.0319%;width:64px;"
    >
      <p class="g-pstyle2">Jo<span class="g-cstyle0">r</span>dan</p>
    </div>
    <div
      id="g-ai0-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:68.1801%;margin-top:-9.6px;left:1.0319%;width:61px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai0-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:74.8889%;margin-top:-9.6px;left:1.0319%;width:47px;"
    >
      <p class="g-pstyle2">I<span class="g-cstyle0">r</span>aq</p>
    </div>
    <div
      id="g-ai0-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:81.5978%;margin-top:-9.6px;left:1.0319%;width:63px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle3">T</span>ur<span class="g-cstyle4">k</span><span
          class="g-cstyle5">e</span
        >y
      </p>
    </div>
    <div
      id="g-ai0-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:88.3067%;margin-top:-9.6px;left:1.0319%;width:47px;"
    >
      <p class="g-pstyle2">I<span class="g-cstyle0">r</span>an</p>
    </div>
    <div
      id="g-ai0-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:95.0155%;margin-top:-9.6px;left:1.0319%;width:53px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">S</span>yria</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-post-15-arms-imports-mideast-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.64968152866242;"
  >
    <div
      id="g-post-15-arms-imports-mideast-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-15-arms-imports-mideast-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.8627%;margin-top:-9.6px;left:72.8271%;width:122px;"
    >
      <p class="g-pstyle0">United Kingdom</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.9901%;margin-top:-9.6px;left:0.7677%;width:111px;"
    >
      <p class="g-pstyle0">Imported from</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.9901%;margin-top:-9.6px;left:24.933%;width:105px;"
    >
      <p class="g-pstyle0">United States</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.9901%;margin-top:-9.6px;left:47.3759%;width:64px;"
    >
      <p class="g-pstyle0">France</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.9901%;margin-top:-9.6px;left:61.6456%;width:48px;"
    >
      <p class="g-pstyle0">Italy</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:4.7927%;margin-top:-9.6px;left:24.933%;width:63px;"
    >
      <p class="g-pstyle0">Russia</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:4.7927%;margin-top:-9.6px;left:47.3759%;width:63px;"
    >
      <p class="g-pstyle0">Others</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.6143%;margin-top:-9.6px;left:0.8748%;width:43px;"
    >
      <p class="g-pstyle1">0%</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.6143%;margin-top:-9.6px;left:22.5052%;width:50px;"
    >
      <p class="g-pstyle1">25%</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.6143%;margin-top:-9.6px;left:46.9185%;width:51px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.6143%;margin-top:-9.6px;left:71.3725%;width:49px;"
    >
      <p class="g-pstyle1">75%</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.6143%;margin-top:-9.6px;left:91.6952%;width:56px;"
    >
      <p class="g-pstyle1">100%</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.8871%;margin-top:-10.2px;left:1.2169%;width:74px;"
    >
      <p class="g-pstyle2">Bah<span class="g-cstyle0">r</span>ain</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.6387%;margin-top:-10.2px;left:1.2169%;width:80px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle1">L</span>ebanon</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:26.1355%;margin-top:-10.2px;left:1.2169%;width:107px;"
    >
      <p class="g-pstyle3">Saudi Arabia</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:33.2693%;margin-top:-10.2px;left:1.2169%;width:59px;"
    >
      <p class="g-pstyle2">Is<span class="g-cstyle0">r</span>ael</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:40.0209%;margin-top:-10.2px;left:1.217%;width:68px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle2">K</span>u<span class="g-cstyle0">w</span>ait
      </p>
    </div>
    <div
      id="g-ai1-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:46.7725%;margin-top:-10.2px;left:1.2169%;width:60px;"
    >
      <p class="g-pstyle2">Qa<span class="g-cstyle0">t</span>ar</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:53.5241%;margin-top:-10.2px;left:1.2168%;width:51px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">U</span>AE</p>
    </div>
    <div
      id="g-ai1-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:60.2756%;margin-top:-10.2px;left:1.2169%;width:67px;"
    >
      <p class="g-pstyle2">Jo<span class="g-cstyle0">r</span>dan</p>
    </div>
    <div
      id="g-ai1-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:67.0272%;margin-top:-10.2px;left:1.2168%;width:63px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai1-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:73.7788%;margin-top:-10.2px;left:1.217%;width:48px;"
    >
      <p class="g-pstyle2">I<span class="g-cstyle0">r</span>aq</p>
    </div>
    <div
      id="g-ai1-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:80.6578%;margin-top:-10.2px;left:1.2169%;width:65px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle4">T</span>ur<span class="g-cstyle5">k</span><span
          class="g-cstyle6">e</span
        >y
      </p>
    </div>
    <div
      id="g-ai1-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:87.4094%;margin-top:-10.2px;left:1.2169%;width:48px;"
    >
      <p class="g-pstyle2">I<span class="g-cstyle0">r</span>an</p>
    </div>
    <div
      id="g-ai1-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:94.161%;margin-top:-10.2px;left:1.2168%;width:55px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">S</span>yria</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-post-15-arms-imports-mideast-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.32;"
  >
    <div
      id="g-post-15-arms-imports-mideast-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post-15-arms-imports-mideast-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.1245%;margin-top:-9.6px;left:0.6058%;width:111px;"
    >
      <p class="g-pstyle0">Imported from</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.1245%;margin-top:-9.6px;left:19.2788%;width:105px;"
    >
      <p class="g-pstyle0">United States</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.1245%;margin-top:-9.6px;left:36.6211%;width:64px;"
    >
      <p class="g-pstyle0">France</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.1245%;margin-top:-9.6px;left:47.6477%;width:48px;"
    >
      <p class="g-pstyle0">Italy</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.1245%;margin-top:-9.6px;left:56.2879%;width:122px;"
    >
      <p class="g-pstyle0">United Kingdom</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.1245%;margin-top:-9.6px;left:76.1665%;width:63px;"
    >
      <p class="g-pstyle0">Russia</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:3.1245%;margin-top:-9.6px;left:87.002%;width:63px;"
    >
      <p class="g-pstyle0">Others</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.4162%;margin-top:-9.1px;left:13.6668%;width:41px;"
    >
      <p class="g-pstyle1">0%</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.4162%;margin-top:-9.1px;left:32.9954%;width:48px;"
    >
      <p class="g-pstyle1">25%</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.4162%;margin-top:-9.1px;left:54.2122%;width:49px;"
    >
      <p class="g-pstyle1">50%</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.4162%;margin-top:-9.1px;left:75.6226%;width:47px;"
    >
      <p class="g-pstyle1">75%</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:8.4162%;margin-top:-9.1px;left:93.9111%;width:54px;"
    >
      <p class="g-pstyle1">100%</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:18.1245%;margin-top:-9.6px;left:5.6722%;width:71px;"
    >
      <p class="g-pstyle2">Bah<span class="g-cstyle0">r</span>ain</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:24.7245%;margin-top:-9.6px;left:4.8063%;width:77px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle1">L</span>ebanon</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:30.9245%;margin-top:-9.6px;left:1.0133%;width:102px;"
    >
      <p class="g-pstyle3">Saudi Arabia</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:37.7245%;margin-top:-9.6px;left:7.8973%;width:56px;"
    >
      <p class="g-pstyle2">Is<span class="g-cstyle0">r</span>ael</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:44.3245%;margin-top:-9.6px;left:6.5949%;width:65px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle2">K</span>u<span class="g-cstyle0">w</span>ait
      </p>
    </div>
    <div
      id="g-ai2-18"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:50.7245%;margin-top:-9.6px;left:7.6222%;width:58px;"
    >
      <p class="g-pstyle2">Qa<span class="g-cstyle0">t</span>ar</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:57.3245%;margin-top:-9.6px;left:8.8154%;width:50px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle3">U</span>AE</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:63.7245%;margin-top:-9.6px;left:6.6677%;width:64px;"
    >
      <p class="g-pstyle2">Jo<span class="g-cstyle0">r</span>dan</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:70.3245%;margin-top:-9.6px;left:7.1586%;width:61px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:76.7245%;margin-top:-9.6px;left:9.2995%;width:47px;"
    >
      <p class="g-pstyle2">I<span class="g-cstyle0">r</span>aq</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:83.3245%;margin-top:-9.6px;left:6.954%;width:63px;"
    >
      <p class="g-pstyle2">
        <span class="g-cstyle4">T</span>ur<span class="g-cstyle5">k</span><span
          class="g-cstyle6">e</span
        >y
      </p>
    </div>
    <div
      id="g-ai2-24"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:89.7245%;margin-top:-9.6px;left:9.3154%;width:47px;"
    >
      <p class="g-pstyle2">I<span class="g-cstyle0">r</span>an</p>
    </div>
    <div
      id="g-ai2-25"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:96.3245%;margin-top:-9.6px;left:8.3768%;width:53px;"
    >
      <p class="g-pstyle2"><span class="g-cstyle0">S</span>yria</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2026-03-11 20:22 -->

<!-- Generated by ai2html v0.101.0 - 2026-03-11 20:22 -->
<!-- ai file: post-15-arms-imports-mideast.ai -->
<style lang="scss">
  #g-post-15-arms-imports-mideast-box,
  #g-post-15-arms-imports-mideast-box .g-artboard {
    margin: 0 auto;
  }
  #g-post-15-arms-imports-mideast-box p {
    margin: 0;
  }
  #g-post-15-arms-imports-mideast-box .g-aiAbs {
    position: absolute;
  }
  #g-post-15-arms-imports-mideast-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post-15-arms-imports-mideast-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post-15-arms-imports-mideast-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post-15-arms-imports-mideast-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post-15-arms-imports-mideast-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) {
      #g-post-15-arms-imports-mideast-md {
        display: block !important;
      }
    }
  }
  #g-post-15-arms-imports-mideast-xs {
    position: relative;
    overflow: hidden;
  }
  #g-post-15-arms-imports-mideast-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-15-arms-imports-mideast-xs .g-pstyle0 {
    font-weight: 300;
    height: 18px;
  }
  #g-post-15-arms-imports-mideast-xs .g-pstyle1 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(166, 166, 166);
  }
  #g-post-15-arms-imports-mideast-xs .g-pstyle2 {
    height: 18px;
  }
  #g-post-15-arms-imports-mideast-xs .g-pstyle3 {
    height: 18px;
    letter-spacing: -0.005em;
  }
  #g-post-15-arms-imports-mideast-xs .g-pstyle4 {
    height: 18px;
    letter-spacing: -0.02em;
  }
  #g-post-15-arms-imports-mideast-xs .g-cstyle0 {
    letter-spacing: -0.003em;
  }
  #g-post-15-arms-imports-mideast-xs .g-cstyle1 {
    letter-spacing: -0.005em;
  }
  #g-post-15-arms-imports-mideast-xs .g-cstyle2 {
    letter-spacing: -0.011em;
  }
  #g-post-15-arms-imports-mideast-xs .g-cstyle3 {
    letter-spacing: -0.068em;
  }
  #g-post-15-arms-imports-mideast-xs .g-cstyle4 {
    letter-spacing: -0.016em;
  }
  #g-post-15-arms-imports-mideast-xs .g-cstyle5 {
    letter-spacing: 0.002em;
  }
  #g-post-15-arms-imports-mideast-sm {
    position: relative;
    overflow: hidden;
  }
  #g-post-15-arms-imports-mideast-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-15-arms-imports-mideast-sm .g-pstyle0 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
  }
  #g-post-15-arms-imports-mideast-sm .g-pstyle1 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    color: rgb(166, 166, 166);
  }
  #g-post-15-arms-imports-mideast-sm .g-pstyle2 {
    height: 19px;
  }
  #g-post-15-arms-imports-mideast-sm .g-pstyle3 {
    height: 19px;
    letter-spacing: -0.005em;
  }
  #g-post-15-arms-imports-mideast-sm .g-cstyle0 {
    letter-spacing: -0.003em;
  }
  #g-post-15-arms-imports-mideast-sm .g-cstyle1 {
    letter-spacing: -0.005em;
  }
  #g-post-15-arms-imports-mideast-sm .g-cstyle2 {
    letter-spacing: -0.011em;
  }
  #g-post-15-arms-imports-mideast-sm .g-cstyle3 {
    letter-spacing: -0.02em;
  }
  #g-post-15-arms-imports-mideast-sm .g-cstyle4 {
    letter-spacing: -0.068em;
  }
  #g-post-15-arms-imports-mideast-sm .g-cstyle5 {
    letter-spacing: -0.016em;
  }
  #g-post-15-arms-imports-mideast-sm .g-cstyle6 {
    letter-spacing: 0.002em;
  }
  #g-post-15-arms-imports-mideast-md {
    position: relative;
    overflow: hidden;
  }
  #g-post-15-arms-imports-mideast-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post-15-arms-imports-mideast-md .g-pstyle0 {
    font-weight: 300;
    height: 18px;
  }
  #g-post-15-arms-imports-mideast-md .g-pstyle1 {
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    color: rgb(166, 166, 166);
  }
  #g-post-15-arms-imports-mideast-md .g-pstyle2 {
    height: 18px;
  }
  #g-post-15-arms-imports-mideast-md .g-pstyle3 {
    height: 18px;
    letter-spacing: -0.005em;
  }
  #g-post-15-arms-imports-mideast-md .g-cstyle0 {
    letter-spacing: -0.003em;
  }
  #g-post-15-arms-imports-mideast-md .g-cstyle1 {
    letter-spacing: -0.005em;
  }
  #g-post-15-arms-imports-mideast-md .g-cstyle2 {
    letter-spacing: -0.011em;
  }
  #g-post-15-arms-imports-mideast-md .g-cstyle3 {
    letter-spacing: -0.02em;
  }
  #g-post-15-arms-imports-mideast-md .g-cstyle4 {
    letter-spacing: -0.068em;
  }
  #g-post-15-arms-imports-mideast-md .g-cstyle5 {
    letter-spacing: -0.016em;
  }
  #g-post-15-arms-imports-mideast-md .g-cstyle6 {
    letter-spacing: 0.002em;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
